'use strict';

var index = require('../../../../function-bind/index.js');

var bind = index;
var has = bind.call(Function.call, Object.prototype.hasOwnProperty);

var $assign = Object.assign;

var assign = function assign(target, source) {
	if ($assign) {
		return $assign(target, source);
	}

	for (var key in source) {
		if (has(source, key)) {
			target[key] = source[key];
		}
	}
	return target;
};

module.exports = assign;
